import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/Inicio'
import Login from '@/components/Login'
import SeleccionEvento from '@/components/SeleccionEvento'
import SeleccionMetodo from '@/components/SeleccionMetodo'
import IngresoManual from '@/components/IngresoManual'
import IngresoManualDocumento from '@/components/IngresoManualDocumento'
import IngresoManualTeclado from '@/components/IngresoManualTeclado'
import IngresoCamara from '@/components/IngresoCamara'
import IngresoCamaraConfirmacion from '@/components/IngresoCamaraConfirmacion'
import IngresoCelular from '@/components/IngresoCelular'
import IngresoCelularTeclado from '@/components/IngresoCelularTeclado'
import IngresoManualSexo from '@/components/IngresoManualSexo'
import IngresoEsCliente from '@/components/IngresoEsCliente'
import Confirmacion from '@/components/Confirmacion'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/evento',
      name: 'SeleccionEvento',
      component: SeleccionEvento
    },
    {
      path: '/metodo',
      name: 'SeleccionMetodo',
      component: SeleccionMetodo
    },
    {
      path: '/manual',
      name: 'IngresoManual',
      component: IngresoManual
    },
    {
      path: '/documento',
      name: 'IngresoManualDocumento',
      component: IngresoManualDocumento
    },
    {
      path: '/doc-teclado',
      name: 'IngresoManualTeclado',
      component: IngresoManualTeclado
    },
    {
      path: '/manual-sexo',
      name: 'IngresoManualSexo',
      component: IngresoManualSexo
    },
    {
      path: '/cliente',
      name: 'IngresoEsCliente',
      component: IngresoEsCliente
    },
    {
      path: '/camara',
      name: 'IngresoCamara',
      component: IngresoCamara
    },
    {
      path: '/camara-conf',
      name: 'IngresoCamaraConfirmacion',
      component: IngresoCamaraConfirmacion
    },
    {
      path: '/celular',
      name: 'IngresoCelular',
      component: IngresoCelular
    },
    {
      path: '/celular-teclado',
      name: 'IngresoCelularTeclado',
      component: IngresoCelularTeclado
    },
    {
      path: '/confirmacion',
      name: 'Confirmacion',
      component: Confirmacion
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js